import React, {FunctionComponent} from 'react';
import {DISTANCE_FEETS, DISTANCE_METERS, DISTANCE_TIME} from '../../../../store/constants';
import TranslateTemplate from '../../TranslateTemplate/TranslateTemplate';


interface IPhotoDistance {
    distance: number;
    time: number;
    unit: string;
    translateText: (id: number) => string;
}

const PhotoDistance: FunctionComponent<IPhotoDistance> = ({distance, time, unit, translateText}) => {

    const DISTANCE_METRICS = unit === 'meters'
        ? DISTANCE_METERS
        : DISTANCE_FEETS;


    return (
        <div className="mb-20 ml-10">
            <TranslateTemplate text = {translateText(DISTANCE_METRICS)} replace = {{distance}}/>
            <span className="border-path" />
            <TranslateTemplate text = {translateText(DISTANCE_TIME)} replace = {{minutes: time}}/>
        </div>
    )
};

export default PhotoDistance;